import { Header as PageHeader } from '@components/Header';

export const Header = () => {
  return <PageHeader title="Audit Log" />;
};
